/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsVideo = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsVideo = $.extend(this, window.PXUTheme.getSectionData($section));
  
  	// Check Have Multiple Video or not
    var multipleVideoSection = false;
    if($section.find('[data-section-two-videos-a-row]').length == 1){
      multipleVideoSection = true;
    }

    // Selectors
    const $videoElement = $section.find('[data-video-element]');
    const $playIcon = $section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
    const $playButton = $section.find('[data-play-button]');
    const $videoTextContainer = $section.find('[data-video-text-container]');
    const $imageElement = $section.find('[data-image-element]');
  
  if(multipleVideoSection == true){
    for(var i = 0; i < $videoElement.length; i++){
      var blockId = $videoElement[i].dataset.blockId;
      var blockJson = JSON.parse(document.querySelector(`[data-block-data="${blockId}"]`).innerText),
          _blockSection = $section.find('[data-section-two-videos-a-row]').find(`.block--${blockId}`),
          _videoElement = $(`[data-block-id="${blockId}"][data-video-element]`),
          _playIcon = _blockSection.find('.plyr--paused.plyr--video .plyr__control--overlaid'),
          _playButton = _blockSection.find('[data-play-button]'),
          _videoTextContainer = _blockSection.find('[data-video-text-container]'),
          _imageElement = _blockSection.find('[data-image-element]');
      
      this.loadVideo(_videoElement, _playIcon, _playButton, _videoTextContainer, _imageElement,blockId,blockJson.poster,blockJson.button);
    }
  }else{
    // Load video if the media has been added
    if (this.iframe_video || this.html5_video) {
      this.loadVideo($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement,this.id,this.poster,this.button);
    } else {
      $imageElement.show();
    }
  }

  },
  loadVideo: function($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement,$id,$poster,$buttonExists) {
    const player = new Plyr(`.video-${$id}`, {
      controls: videoControls,
      clickToPlay:true,
      loop: {
        active: this.autoloop
      },
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      },
      youtube:{
        modestbranding:1
      }
    });

    player.muted = this.mute;
    player.ratio = this.aspect_ratio;

    // If autoplay enabled, hide image and text
    if (this.autoplay) {
      player.autoplay = true;
      $imageElement.hide();
      $videoTextContainer.hide();
      $videoElement.show();
    } else {
      // If autoplay disabled, check if poster image added
      if ($poster) {
        $videoElement.hide();
        $imageElement.show();
        $videoTextContainer.show();
      } else {
        // If autoplay disabled and no poster image
        $imageElement.hide();
        $videoElement.show();
        $videoTextContainer.show();
      }
    }

    // If button exists, clicking button will play video
    if ($buttonExists) {
      $playButton.on('click', function(){
        player.play();
      })
    }

    // Clicking anywhere on video should play the video
    if (!$buttonExists) {
      $videoTextContainer.on('click', function(){
        player.play();
      })
    }
    
    // If on mobile and text is below image, clicking the image wrapper should play the video
    if (!isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
      $imageElement.on('click', function(){
        player.play();
      })
    }

    // On player ready, hide play icon if play button visible
    player.on('ready', function(index) {
      if(player.autoplay == true){
        player.play();
      }
      if ($playButton && !isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
        $playIcon.show();
      } else if ($playButton) {
        $playIcon.hide();
      } else {
        $playIcon.show();
      }
    })

    // On play, hide image/text and show video element
    player.on('play', function(index, player) {
      $videoElement.show();
      $imageElement.hide();
      $videoTextContainer.hide();
    })

    // On player pause, show play icon if play button hidden
    player.on('pause', function(index, player) {
      if (!$playButton) {
        $playIcon.show();
      }
    })

  },
  unload: function($section) {
    const $playButton = $section.find('[data-play-button]');
    const $videoTextContainer = $section.find('[data-video-text-container]');

    $playButton.off();
    $videoTextContainer.off();
  }
}

/******/ })()
;